/**
 * Server-client helper functions.
 * shared logic that can be used on both server and client side.
 * This file must not contain any server-only / Node specific logic.
 */
const { authenticationErrors } = require('./constants');

module.exports = {
  getAuthenticationError(error) {
    if (error === authenticationErrors.TOKEN_EXPIRED) {
      return authenticationErrors.TOKEN_EXPIRED;
    }
    if (error === authenticationErrors.TOKEN_EXPIRED_WHILE_LOGGED_IN) {
      return authenticationErrors.TOKEN_EXPIRED_WHILE_LOGGED_IN;
    }
    if (error === authenticationErrors.LOGIN_FAILED) {
      return authenticationErrors.LOGIN_FAILED;
    }

    return authenticationErrors.NONE;
  },
  getCasIDFromURL(casURL) {
    if (!casURL) return '';
    const urlSplitCas = casURL.split('/');
    if (!urlSplitCas.length) return '';
    const casID = urlSplitCas[urlSplitCas.length - 1].split('.')[0];
    if (!casID) return '';
    return casID;
  },
};
